export const projectDetailOnboardingTips = {
  outline: {
    title: { en: 'Outline Manager', 'zh-CN': '大纲管理器' },
    description: { 
      en: 'Create and manage your presentation outline here. Use AI to auto-generate or manually build your slide structure.',
      'zh-CN': '在这里创建和管理您的演示大纲。可以使用AI自动生成或编辑幻灯片结构。'
    }
  },
  missingTemplate: {
    title: { en: 'Missing PPTX Template', 'zh-CN': '缺少PPTX模板' },
    description: {
      en: 'Before you can add slides, please choose a PPTX template in the Settings tab. This template will define the structure and design of your presentation.',
      'zh-CN': '在添加幻灯片之前，请先在“设置”选项卡中选择一个PPTX模板。该模板将定义演示文稿的结构和设计。'
    }
  },
  slides: {
    title: { en: 'Slides Editor', 'zh-CN': '幻灯片编辑器' },
    description: { 
      en: 'Edit individual slides, customize content, and use AI helpers to enhance your presentation with smart suggestions. Preview image is only for reference, the content is not generated successfully, the actual generated and modified content needs to be downloaded to view.',
      'zh-CN': '编辑各个幻灯片，自定义内容，并使用AI助手辅助生成和编辑幻灯片各个元素。注意：预览图仅用于参考，并非内容未生成成功，实际生成和修改的内容需要生成PPT下载查看。'
    }
  },
  images: {
    title: { en: 'Images', 'zh-CN': '图片' },
    description: { 
      en: 'Manage images for this project. Upload your own pictures or generate them using AI for perfect visual content.',
      'zh-CN': '管理此项目的图片。上传您自己的图片或使用AI生成图片，获得完美的视觉内容。'
    }
  },
  materials: {
    title: { en: 'Materials', 'zh-CN': '材料' },
    description: { 
      en: 'Attach reference documents to this project. These materials can be used as context when generating slide content.',
      'zh-CN': '为此项目附加参考文档。这些材料可以在生成幻灯片内容时用作上下文参考。'
    }
  },
  settings: {
    title: { en: 'Settings', 'zh-CN': '设置' },
    description: { 
      en: 'Configure project settings including template selection, project details, and other preferences.',
      'zh-CN': '配置项目设置，包括模板选择、项目详情和其他首选项。'
    }
  },
  export: {
    title: { en: 'Build PPT', 'zh-CN': '生成PPT' },
    description: { 
      en: 'Export your completed presentation as a PowerPoint file. Make sure all slides have proper templates assigned first.',
      'zh-CN': '将完成的演示文稿导出为PowerPoint文件。生成前请确保所有幻灯片都已分配适当的模板。'
    }
  }
}; 